import {Image} from '@shopify/hydrogen'
import {Fade} from 'react-awesome-reveal'

import ToggleTab from '~/components/common/ToggleTab.client'
import Aside from '~/components/common/Aside.client'
import Button from '~/components/button/Button.client'
import HowtoWelcome from '~/components/page/HowtoWelcome.client'
import HowtoStep from '~/components/page/HowtoStep.client'

import localeJa from '~/locales/ja.json'
import localeEn from '~/locales/en.json'

import img1 from '~/assets/images/send_img01.jpg'
import img2_ja from '~/assets/images/send_img02_ja.jpg'
import img3_ja from '~/assets/images/send_img03_ja.jpg'
import img4_ja from '~/assets/images/send_img04_ja.jpg'
import img5_ja from '~/assets/images/send_img05_ja.jpg'
import img2 from '~/assets/images/send_img02_en.jpg'
import img3 from '~/assets/images/send_img03_en.jpg'
import img4 from '~/assets/images/send_img04_en.jpg'
import img5 from '~/assets/images/send_img05_en.jpg'

/**
 * A client component that sets the primary and secondary classes for button components
 */
export default function PageHowToSend({country}) {
  const locale = country.isoCode == 'JP' ? localeJa : localeEn
  // const font_en = country.isoCode !== 'JP' ? '!font-roboto' : ''
  const howto = locale.howto
  const data = locale.howtosend

  return (
    <>
      <Fade>
        <HowtoWelcome data={howto} />

        <div
          className="
    bg-white py-10
    md:bg-transparent md:pt-0"
        >
          <div className="content-wrapper">
            <div
              className="
        -mx-8 mb-8 px-8
        sm:-mx-16
        md:mb-12
        border-b border-gray-100
        "
            >
              <ToggleTab
                className="
          w-full mx-auto pb-10
          sm:w-96
          "
                items={[
                  {
                    label: howto.tab.send,
                    url: '/pages/howtosend',
                    active: true,
                  },
                  {
                    label: howto.tab.receive,
                    url: '/pages/howtoreceive',
                    active: false,
                  },
                ]}
              />
            </div>

            <div className="mb-16">
              <HowtoStep step="1" title={data.steps[0].title} />
              <p className="mb-8">
                <Image
                  src={img1}
                  width="640"
                  height="360"
                  alt="Thumbnail"
                  className="w-full"
                />
              </p>
              <p className="mb-8 font-yugo whitespace-pre-line">
                {data.steps[0].text}
              </p>
            </div>

            <div className="mb-16">
              <HowtoStep step="2" title={data.steps[1].title} />
              <p className="mb-8">
                <Image
                  src={country.isoCode === 'JP' ? img2_ja : img2}
                  width="640"
                  height="360"
                  alt="Thumbnail"
                  className="w-full"
                />
              </p>
              <p className="font-yugo whitespace-pre-line">
                {data.steps[1].text}
              </p>
            </div>

            <div className="mb-16">
              <HowtoStep step="3" title={data.steps[2].title} />
              <p className="mb-8">
                <Image
                  src={country.isoCode === 'JP' ? img3_ja : img3}
                  width="640"
                  height="360"
                  alt="Thumbnail"
                  className="w-full"
                />
              </p>
              <p className="font-yugo whitespace-pre-line">
                {data.steps[2].text}
              </p>
            </div>

            <div className="mb-16">
              <HowtoStep step="4" title={data.steps[3].title} />
              <p className="mb-8">
                <Image
                  src={country.isoCode === 'JP' ? img4_ja : img4}
                  width="640"
                  height="360"
                  alt="Thumbnail"
                  className="w-full"
                />
              </p>
              <p className="mb-8 font-yugo whitespace-pre-line">
                {data.steps[3].text}
              </p>
              <Button
                className="text-sm font-bold py-4 w-72"
                label={data.steps[3].btn}
                handleClick=""
                url="/pages/howtoreceive"
                variant="secondary"
                passthroughProps=""
              />
            </div>

            <div className="mb-16">
              <HowtoStep step="5" title={data.steps[4].title} />
              <p className="mb-8">
                <Image
                  src={country.isoCode === 'JP' ? img5_ja : img5}
                  width="640"
                  height="360"
                  alt="Thumbnail"
                  className="w-full"
                />
              </p>
              <p className="mb-8 font-yugo">{data.steps[4].text}</p>
              <Aside className="" title={data.steps[4].aside.title}>
                {data.steps[4].aside.text}
              </Aside>
            </div>
          </div>
        </div>
      </Fade>
    </>
  )
}
